import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import CustomRatesTable from "../components/CustomRatesTable";
import GlobalRatesTable from "../components/GlobalRatesTable";
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaBell } from "react-icons/fa";
import { FaLock, FaCoins, FaShieldAlt, FaRocket,  FaStore,
  FaGem,
  FaExternalLinkAlt } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import NotificationSettingsModal from "../components/NotificationSettingsModal";


// Styled Components
const Container = styled.div`
  background-color: #000;
  color: #f5d76e;
  font-family: 'Segoe UI', sans-serif;
  min-height: 100vh;
`;

const Header = styled.header`
  background-color: #f5d76e;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
`;

const HeaderInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;

  img {
    border-radius: 50%;
  }

  span {
    font-weight: 700;
    font-size: 1.3rem;
  }
`;




const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  padding-bottom: 1rem;

  button {
    background-color: #000;
    color: #f5d76e;
    padding: 0.4rem 0.9rem;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background-color: #222;
    }
  }

  @media (min-width: 768px) {
    padding-bottom: 0;
  }
`;

const MenuToggle = styled.button`
  display: block;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #000;

  @media (min-width: 768px) {
    display: none;
  }
`;

const NavMenu = styled.div`
  display: ${({ open }) => (open ? "block" : "none")};
  background-color: #f5d76e;
  width: 100%;
  margin-top: 1rem;

  @media (min-width: 768px) {
    display: none; /* Hide mobile menu on desktop */
  }
`;


const NavLinks = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;

  a {
    color: #000;
    text-decoration: none;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    background: #fef7cc;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #000;
      color: #fff;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    padding-bottom: 0;
  }
`;



const Section = styled.section`
  max-width: 1150px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #f5d76e;
  padding-bottom: 0.5rem;
  margin-bottom: 1.5rem;
`;

const RatesGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const StyledFooter = styled.footer`
  background:    #0e1115ff;

  color: #ccc;
  padding: 3rem 1.5rem 2rem;
  font-size: 0.95rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 1150px;
  margin: 0 auto 2rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const FooterCol = styled.div``;

const FooterTitle = styled.h4`
  color: #f5d76e;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const FooterText = styled.p`
  margin-bottom: 0.5rem;
  color: #eee;
  font-size: 0.94rem;
`;

const FooterLink = styled.a`
  display: block;
  color: #bbb;
  margin-bottom: 0.4rem;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: #f5d76e;
  }
`;

const BottomNote = styled.div`
  text-align: center;
  color: #666;
  border-top: 1px solid #333;
  padding-top: 1rem;
  font-size: 0.85rem;
`;

const BankGrid = styled.div`
  display: grid;
  gap: 2rem;bottom
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const BankCard = styled.div`
  background: #0d0f13ff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover,
  &:active {
    background: #171a20ff;
    transform: scale(1.02);
    cursor: pointer;
  }
`;

const CardHeading = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  color: #f5d76e;
  margin-bottom: 1.5rem;
`;

const CardRow = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.p`
  font-size: 0.9rem;
  color: #ccc;
  margin-bottom: 0.2rem;
`;

const Value = styled.p`
  font-weight: 600;
  color: #fff;
`;

const CopyButton = styled.button`
  font-size: 0.8rem;
  background: transparent;
  border: 1px solid #f5d76e;
  color: #f5d76e;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #f5d76e;
    color: #000;
  }
`;



const QrImage = styled.img`
  width: 120px;
  margin: 0.5rem 0 1rem 0;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
`;


const InfoCard = styled.div`
  background: #0d0f13ff;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1.5rem;
  color: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
`;

const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  margin-bottom: 1rem;

  svg {
    font-size: 1.35rem;   /* 🔥 THIS FIXES IT */
    color: #f5d76e;
    margin-top: 3px;     /* aligns with text baseline */
    flex-shrink: 0;
  }

  p {
    margin: 0;
    line-height: 1.6;
    color: #ddd;
  }

  a {
    color: #f5d76e;
    text-decoration: none;
    font-weight: 500;
  }

  a:hover {
    text-decoration: underline;
  }
`;



const FeaturesSection = styled.section`
  max-width: 1150px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  background-color: #0e0e0e;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
`;

const FeaturesGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
`;

const FeatureItem = styled.div`
  background-color: #141414;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 1.5rem;
  color: #f5d76e;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: #1f1f1f;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 215, 0, 0.1);
  }

  svg {
    font-size: 2rem;
    margin-bottom: 0.75rem;
    color: #ffd700;
  }

  h4 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  p {
    font-size: 0.9rem;
    color: #dcdcdc;
  }
`;


const NewsTicker = styled.div`
  background: #222;
  color: #f5d76e;
  padding: 0.4rem 1rem;
  overflow: hidden;
  white-space: nowrap;

  span {
    display: inline-block;
    padding-left: 100%;
    animation: scroll-left 20s linear infinite;
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

const FloatingButtons = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  button.floating-bell-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #000;
    color: #f5d76e;
    border: 1.5px solid #d4af37;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.15rem;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), 0 0 10px rgba(212, 175, 55, 0.25);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-2px) scale(1.08);
      background: #111;
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5), 0 0 15px rgba(212, 175, 55, 0.45);
    }
  }

  a {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #e77575ff;
    color: white;
    padding: 0.6rem 1rem;
    border-radius: 50px;
    text-decoration: none;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    &:hover {
      background-color: #ea1717ff;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
`;


const Left = styled.div`
  display: flex;
  align-items: center;
`;

const Right = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 0.6rem;
    align-items: center;
  }
`;

const CenterNav = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 2rem;
  }
`;

const LoginBtn = styled.button`
  background: transparent;
  border: 2px solid #000;
  color: #000;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #000;
    color: #f5d76e;
  }
`;

const RegisterBtn = styled.button`
  background: #000;
  color: #f5d76e;
  padding: 0.4rem 0.9rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background-color: #222;
  }
    @keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

`;


const JewelleryNote = styled.div`
  margin-top: 2.2rem;
  padding: 0.9rem 1rem;
  border-left: 3px solid #f5d76e;
  background: rgba(245, 215, 110, 0.05);
  border-radius: 8px;

  .label {
    display: inline-block;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    color: #f5d76e;
    margin-bottom: 0.3rem;
    text-transform: uppercase;
    font-weight: 600;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    color: #ddd;
    line-height: 1.5;
  }

  a {
    color: #f5d76e;
    font-weight: 500;
    text-decoration: none;
    margin-left: 4px;
  }

  a:hover {
    text-decoration: underline;
  }
`;




const Home = () => {
  const [rates, setRates] = useState({ custom: [], global: [] });
  const [loading, setLoading] = useState(true);

  // --- Your other states remain unchanged ---
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotifModal, setShowNotifModal] = useState(false);
  const [showLoginMessage, setShowLoginMessage] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // 🔔 1-time polite notification permission prompt after initial visit
  useEffect(() => {
    const hasPrompted = localStorage.getItem("gj_notif_prompt_shown");
    const hasToken = localStorage.getItem("gj_fcm_token");
    if (!hasPrompted && !hasToken) {
      const timer = setTimeout(() => {
        setShowNotifModal(true);
        localStorage.setItem("gj_notif_prompt_shown", "true");
      }, 3500); // Prompts after 3.5 seconds of user browsing
      return () => clearTimeout(timer);
    }
  }, []);

  // --- This user effect remains unchanged ---
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const justLoggedIn = localStorage.getItem("justLoggedIn");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);

        if (justLoggedIn === "true") {
          setShowLoginMessage(true);
          setTimeout(() => {
            setShowLoginMessage(false);
            localStorage.removeItem("justLoggedIn");
          }, 3000);
        }

      } catch (err) {
        console.error("Error parsing user:", err);
      }
    }
  }, []);

  useEffect(() => {
    const readCachedRates = () => {
      try {
        const cachedRates = localStorage.getItem("gjBullionLastRates");
        return cachedRates ? JSON.parse(cachedRates) : null;
      } catch (error) {
        console.error("Failed to parse cached rates:", error);
        return null;
      }
    };

    const fetchRates = async () => {
      try {
        const res = await fetch(`https://bullion-backend-5pu3.onrender.com/api/rates`, {
          cache: "no-store",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });

        if (!res.ok) {
          throw new Error(`Rates request failed with ${res.status}`);
        }

        const data = await res.json();

        if (data && data.custom && data.global) {
          setRates({ custom: data.custom, global: data.global });

          localStorage.setItem(
            "gjBullionLastRates",
            JSON.stringify({
              custom: data.custom,
              global: data.global,
              timestamp: data.timestamp || new Date().toISOString(),
            })
          );
        }
      } catch (error) {
        console.error("Failed to fetch rates:", error);

        const cachedRates = readCachedRates();
        if (cachedRates?.custom && cachedRates?.global) {
          setRates({
            custom: cachedRates.custom,
            global: cachedRates.global,
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 2000); // har 2 sec live
    return () => clearInterval(interval);
  }, []);

  console.log("✅ Final User from state:", user);

  return (

    <Container>
      {showLoginMessage && user?.fullName && (
  <div style={{
    backgroundColor: "#d4edda",
    color: "#155724",
    padding: "1rem",
    marginBottom: "1rem",
    border: "1px solid #c3e6cb",
    borderRadius: "8px",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "16px",
    animation: "fadeSlideIn 0.5s ease-out"
  }}>
    ✅ Thank you for login, {user.fullName.split(" ")[0]}! Now you can place the trade.
  </div>
)}
      <Header>
        <HeaderInner>
          <Left>
            <Brand>
              <img
                src="/assets/logo.jpeg"
                alt="GJ Bullion Logo"
                style={{ width: "40px", height: "40px", marginRight: "0.5rem", borderRadius: "50%", objectFit: "cover" }}
              />
              <span>GJ Bullion</span>
            </Brand>
          </Left>

          <CenterNav>
            <NavLinks>
<HashLink
  smooth
  to="/#rates"
  onClick={() => setMenuOpen(false)}
  title="Live Indore Gold & Silver Rates"
>
  Live Rates
</HashLink>

<HashLink
  smooth
  to="/#booking"
  onClick={() => setMenuOpen(false)}
  title="Best Bullion Booking Desk in Indore"
>
  Booking Desk
</HashLink>

<Link
  to="/trades"
  onClick={() => setMenuOpen(false)}
  title="View Your Trade History with GJ Bullion"
>
  Trades
</Link>

<Link
  to="/about"
  onClick={() => setMenuOpen(false)}
  title="About GJ Bullion(Owned by Daksh & Piyush Soni )"
>
  About Us
</Link>

<Link
  to="/privacy-policy"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Privacy Policy"
>
  Privacy Policy
</Link>

<Link
  to="/terms-and-conditions"
  onClick={() => setMenuOpen(false)}
  title="GJ Bullion Terms & Conditions"
>
  Terms & Conditions
</Link>
<a
  href="https://jaggannathjewellers.netlify.app/"
  target="_blank"
  rel="noopener noreferrer"
  className="nav-link"
>
  💍Shop Jewellery
</a>

            </NavLinks>
          </CenterNav>

          <Right>
  {user?.fullName ? (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setShowProfileMenu(!showProfileMenu)}
        style={{
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          background: "transparent",
          border: "2px solid #000",
          borderRadius: "6px",
          padding: "0.4rem 0.8rem",
          cursor: "pointer",
          color: "#000"
        }}
      >
        👤 {user.fullName.split(" ")[0]}
      </button>

      {showProfileMenu && (
        <div style={{
          position: "absolute",
          top: "110%",
          right: 0,
          background: "#fff",
          color: "#000",
          padding: "0.75rem 1rem",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
          zIndex: 100
        }}>
          <p><strong>Name:</strong> {user.fullName}</p>
          <p><strong>Phone:</strong> {user.phone}</p>
          <button
            style={{
              marginTop: "0.5rem",
              background: "#e53935",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              padding: "0.4rem 0.75rem",
              cursor: "pointer"
            }}
            onClick={() => {
              localStorage.removeItem("user");
              setUser(null);
              setShowProfileMenu(false);
              navigate("/");
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  ) : (
    <>
      <Link to="/login"><LoginBtn>Login</LoginBtn></Link>
      <Link to="/register"><RegisterBtn>Register</RegisterBtn></Link>
    </>
  )}
</Right>


          <MenuToggle onClick={() => setMenuOpen(!menuOpen)}>☰</MenuToggle>
        </HeaderInner>

        <NavMenu open={menuOpen}>




          <NavLinks>
            <a href="#rates" onClick={() => setMenuOpen(false)}>Live Rates</a>
            <a href="#booking" onClick={() => setMenuOpen(false)}>Booking Desk</a>
            <Link to="/trades" onClick={() => setMenuOpen(false)}>Trades</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
            <a href="/privacy-policy" onClick={() => setMenuOpen(false)}>Privacy Policy</a>
            <a href="/terms-and-conditions" onClick={() => setMenuOpen(false)}>Terms & Conditions</a>
            <a
  href="https://jaggannathjewellers.netlify.app/"
  target="_blank"
  rel="noopener noreferrer"
  className="nav-link"
>
  💍Shop Jewellery
</a>
          </NavLinks>

                    {/* 👤 Mobile profile */}
<ButtonGroup>
  {!user?.fullName ? (
    <>
      <Link to="/login"><button>Login</button></Link>
      <Link to="/register"><button>Register</button></Link>
    </>
  ) : (
    <>
      <button
        onClick={() => setShowProfileMenu(!showProfileMenu)}
        style={{
          fontWeight: 600,
          border: "2px solid #000",
          borderRadius: "6px",
          padding: "0.4rem 0.8rem",
          color: "#000",
          background: "transparent",
          width: "100%",
          textAlign: "left",
          marginBottom: "0.5rem"
        }}
      >
        👤 {user.fullName.split(" ")[0]}
      </button>
      {showProfileMenu && (
        <div style={{
          background: "#fff",
          color: "#000",
          padding: "0.75rem",
          borderRadius: "8px",
          marginTop: "0.5rem",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          fontSize: "0.9rem"
        }}>
          <p><strong>Name:</strong> {user.fullName}</p>
          <p><strong>Phone:</strong> {user.phone}</p>
          <button
            style={{
              marginTop: "0.5rem",
              background: "#e53935",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              padding: "0.4rem 0.75rem",
              cursor: "pointer"
            }}
            onClick={() => {
              localStorage.removeItem("user");
              setUser(null);
              setShowProfileMenu(false);
              setMenuOpen(false);
              navigate("/");
            }}
          >
            Logout
          </button>
        </div>
      )}
    </>
  )}
</ButtonGroup>
        </NavMenu>
      </Header>



<div
  style={{
    backgroundImage: 'url(/assets/hero-bg.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '4rem 1rem',
    color: '#fff',
    textAlign: 'center',
    position: 'relative',
  }}
>
  <div
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      padding: '3rem 1rem',
      borderRadius: '12px',
      maxWidth: '700px',
      margin: '0 auto',
    }}
  >
    <h1
      style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        color: '#FFD700',
      }}
    >
      Start Trading Gold & Silver with Confidence
    </h1>
    <p
      style={{
        fontSize: '1rem',
        lineHeight: '1.6',
        marginBottom: '2rem',
      }}
    >
      Transparent pricing, secure bookings, and lightning-fast execution — all in one place.
    </p>
    

{user?.fullName ? (
  <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
    <a
      href="#rates"
      style={{
        textDecoration: 'none',
      }}
    >
      <button
        style={{
          backgroundColor: '#FFD700',
          color: '#000',
          border: 'none',
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Trade Now
      </button>
    </a>

    <Link to="/trades">
      <button
        style={{
          backgroundColor: '#333',
          color: '#fff',
          border: 'none',
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        View History
      </button>
    </Link>
  </div>
) : (
  <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
    <Link to="/login">
      <button
        style={{
          backgroundColor: '#FFD700',
          color: '#000',
          border: 'none',
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Login
      </button>
    </Link>

    <Link to="/register">
      <button
        style={{
          backgroundColor: '#333',
          color: '#fff',
          border: 'none',
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Register
      </button>
    </Link>
  </div>
)}

  </div>
</div>




<NewsTicker>
  <span>📣 Welcome to GJ BULLION a Trsuted Place For Booking Gold/Silver • The Best place to buy & sell Gold & Silver bullion • Trading Time Monday To Saturday 12:00 pm End Time 6:30 pm  • All prices updated every second! </span>
</NewsTicker>

      <Section id="rates">
        <SectionTitle>📈 Live Bullion Rates</SectionTitle>
        {loading ? (
          <div style={{ textAlign: "center", color: "#ccc" }}>Loading rates...</div>
        ) : (
<RatesGrid>
  <CustomRatesTable rates={rates.custom} />
  <GlobalRatesTable rates={rates.global} />
</RatesGrid>
        )}
      </Section>

<Section id="jewellery">
  <SectionTitle>💍 Our Jewellery Store</SectionTitle>

  <InfoCard>
    <InfoRow>
      <FaStore />
      <p>
        <strong>Showroom:</strong> JAGANNATH JEWELLERS
      </p>
    </InfoRow>

    <InfoRow>
      <FaGem />
  <p>
Jaggannath Jewellers is a trusted destination for authentic gold and silver jewellery, offering a perfect blend of traditional craftsmanship and modern design. Our showroom features a carefully curated collection of hallmarked jewellery for daily wear, weddings, festivals, and special occasions. With a strong commitment to purity, transparent pricing, and customer satisfaction, every piece is crafted to reflect elegance, quality, and timeless value.
  </p>
    </InfoRow>

    <InfoRow>
      <FaExternalLinkAlt />
      <p>
        <strong>Visit Store:</strong>{" "}
        <a
          href="https://jaggannathjewellers.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          jaggannathjewellers.netlify.app
        </a>
      </p>
    </InfoRow>
  </InfoCard>
</Section>


      <Section id="booking">
  <SectionTitle>📞 Booking Desk</SectionTitle>

  <InfoCard>
    <InfoRow>
      <FaMapMarkerAlt />
      <p><strong>Address:</strong> 5, SHIV MARG, JOBAT</p>
    </InfoRow>
    <InfoRow>
      <FaEnvelope />
      <p><strong>Email:</strong> <span style={{ color: "#f5d76e" }}>GJBULLIION@GMAIL.COM</span></p>
    </InfoRow>
    <InfoRow>
      <FaPhone />
      <p><strong>Mobile:</strong> +91-9179315759, +91-8878910881</p>
    </InfoRow>
  </InfoCard>
</Section>



      <Section id="bank-details">
  <SectionTitle>🏦 Bank Details</SectionTitle>
  <BankGrid>
    <BankCard>
      <CardHeading>Primary Trading Account</CardHeading>
      <CardRow><Label>Bank Name</Label><Value>HDFC BANK</Value></CardRow>
      <CardRow><Label>Account Name</Label><Value>PIYUSH SONI</Value></CardRow>
      <CardRow>
        <Label>Account Number</Label>
        <Value style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          50200102486672
          <CopyButton
            onClick={() => navigator.clipboard.writeText("50200102486672")}
          >
            Copy
          </CopyButton>
        </Value>
      </CardRow>
      <CardRow><Label>IFSC Code</Label><Value>HDFC0007516</Value></CardRow>
    </BankCard>

    <BankCard>
  <CardHeading>UPI Payment</CardHeading>

  <CardRow>
    <Label>UPI ID</Label>
        <Value style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    PIYUSHSONI88@YBL
    <CopyButton
            onClick={() => navigator.clipboard.writeText("PIYUSHSONI88@YBL")}
          >
            Copy
          </CopyButton>
          </Value>
  </CardRow>

  {/* Move the QR code here */}
  <QrImage src="/assets/qr.jpg" alt="UPI QR" />

  <CardRow>
    <Label>Supported Apps</Label>
    <Value>PhonePe, Google Pay, Paytm, BHIM</Value>
  </CardRow>
</BankCard>


  </BankGrid>
</Section>

<FeaturesSection>
  <SectionTitle>🚀 Why Choose GJ BULLION?</SectionTitle>
  <FeaturesGrid>
    <FeatureItem>
      <FaCoins />
      <h4>Live Market Rates</h4>
      <p>Stay updated with real-time gold & silver pricing.</p>
    </FeatureItem>
    <FeatureItem>
      <FaShieldAlt />
      <h4>100% Purity Assurance</h4>
      <p>All trades backed by guaranteed Gold/Silver quality.</p>
    </FeatureItem>
    <FeatureItem>
      <FaLock />
      <h4>Safe & Secure</h4>
      <p>Fully protected trading with industry-grade security.</p>
    </FeatureItem>
    <FeatureItem>
      <FaRocket />
      <h4>Fast Transactions</h4>
      <p>Book and trade in seconds without delays.</p>
    </FeatureItem>
  </FeaturesGrid>
</FeaturesSection>

<FloatingButtons>
  <button
    type="button"
    className="floating-bell-btn"
    onClick={() => setShowNotifModal(true)}
    title="Live Rate Notification Settings"
    aria-label="Notification Settings"
  >
    <FaBell />
  </button>
  <a href="https://wa.me/919179315759" target="_blank" rel="noopener noreferrer">
    <img src="/assets/whatsapp.png" alt="WhatsApp" />
  </a>
  <a href="tel:+919179315759">📞</a>
</FloatingButtons>



      <StyledFooter>
  <FooterGrid>
    <FooterCol>
  <FooterTitle>GJ BULLION</FooterTitle>

  <FooterText>
    Proudly serving traders and investors with honest pricing and real-time rates.
    Trusted by jewellers, wholesalers, and bullion buyers across India.
  </FooterText>

  <FooterText style={{ marginTop: "0.6rem" }}>
    Shop authentic gold & silver jewellery from our own showroom —{" "}
    <a
      href="https://jaggannathjewellers.netlify.app/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#f5d76e",
        textDecoration: "none",
        fontWeight: 800
      }}
    >
      Jaggannath Jewellers
    </a>
  </FooterText>
</FooterCol>


    <FooterCol>
      <FooterTitle>Quick Links</FooterTitle>
      <FooterLink href="#rates">Live Rates</FooterLink>
      <FooterLink href="#booking">Booking Desk</FooterLink>
      <FooterLink href="/trades">Trade History</FooterLink>
      <FooterLink href="/about">About Us</FooterLink>
      <FooterLink href="https://jaggannathjewellers.netlify.app" target="_blank">Shop Jewellery</FooterLink>
      <FooterLink
        href="https://play.google.com/store/apps/details?id=com.gjbullion.app&pcampaignid=web_share"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#48ff91", fontWeight: 600 }}
      >
        📲 Download Android App
      </FooterLink>
    </FooterCol>

    <FooterCol>
      <FooterTitle>Contact</FooterTitle>
      <FooterText>📍 5, SHIV MARG, JOBAT</FooterText>
      <FooterText>📞 +91 9179315759 +91 8878910881</FooterText>
      <FooterText>✉️ GJBULLIION@GMAIL.COM</FooterText>
    </FooterCol>

    
  </FooterGrid>

  <BottomNote className="bordered">
  © 2025 GJ BULLION. All rights reserved. &nbsp;&nbsp;|&nbsp;&nbsp;
  Developed by — <a href="https://codestatiion.netlify.app/" target="_blank" rel="noopener noreferrer">CODE STATIION</a>
</BottomNote>


</StyledFooter>

      {/* 🔔 Notification Opt-in & Preferences Modal */}
      <NotificationSettingsModal
        isOpen={showNotifModal}
        onClose={() => setShowNotifModal(false)}
      />

    </Container>
  );
};


export default Home;





